import { createFileRoute } from '@tanstack/react-router';
import { devicesQuery } from '@/features/devices/api';
import { MonitoringIndicatorsPage } from '@/features/devices/monitoring/MonitoringIndicatorsPage';

/** "Fizik ko'rsatkichlar" monitoring (584:15665). */
export const Route = createFileRoute('/_authed/t/$tenantSlug/_shell/monitoring/physical')({
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(devicesQuery(context.tenant.id));
  },
  component: MonitoringPhysicalRoute,
});

function MonitoringPhysicalRoute() {
  const { tenant } = Route.useRouteContext();
  return <MonitoringIndicatorsPage tenant={tenant} kind="physical" />;
}
